<template>
  <AddRule update />
</template>
<script>
import appConfig from '@/app.config'
import AddRule from '../../../components/dadban/rules/AddRule.vue'
export default {
  page: {
    title: 'ویرایش قوانین',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-rules',
  components: {
    AddRule,
  },
}
</script>
